import semver from 'semver'
import { trpc } from 'api'
import useRemoteConfigParams from 'storage/useRemoteConfigParams'
import { AllVersionStatus, AppVersionStatus, CmsVersionStatus } from './types'
import AppConfig from 'config'
import { useMemo } from 'react'
import findKey from 'utils/findKey'

export const getAppsStatuses = (
  client: string,
  server?: string
): { client: AppVersionStatus; server: AppVersionStatus } => {
  if (!server) return { client: 'unknown', server: 'unknown' }
  if (semver.gt(client, server)) return { client: 'ahead', server: 'behind' }
  if (semver.gt(server, client)) return { client: 'behind', server: 'ahead' }
  return { client: 'synched', server: 'synched' }
}

export const useCmsVersion = () => {
  const { params } = useRemoteConfigParams()
  const { data, isLoading } = trpc.config.versions.useQuery({
    region: params.region,
  })

  return useMemo(() => {
    let status: CmsVersionStatus = 'unknown'
    if (params.state === 'public') status = 'public'
    if (params.state === 'preview') status = 'preview'
    if (params.versionId) status = 'manual'

    let result = undefined

    if (status === 'manual')
      result = data?.find((v) => v.id === params.versionId)
    if (status === 'public') result = data?.[0]

    return {
      status,
      result,
      isLoading,
    }
  }, [data, isLoading, params])
}

export const getAllStatus = ({
  client,
  server,
  cms,
}: {
  client: AppVersionStatus
  server: AppVersionStatus
  cms: CmsVersionStatus
}): AllVersionStatus => {
  const isDev = AppConfig.isDev

  if (client === 'behind') return 'danger'
  if (server === 'behind') return 'warning'
  if (cms === 'preview' && !isDev) return 'warning'
  if (cms === 'manual') return 'danger'

  return 'neutral'
}

export const findVersionInObject = (obj: any): string | null | undefined => {
  const foundValue = findKey(obj, 'version')
  if (typeof foundValue !== 'string') return undefined
  return semver.valid(foundValue)
}
